package kz.dentalcrm.app.data.network

import io.ktor.client.HttpClient
import io.ktor.client.request.header
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.HttpMethod
import io.ktor.http.contentType
import io.ktor.http.headers
import io.ktor.http.path
import kz.dentalcrm.app.core.network.handle
import kz.dentalcrm.app.core.storage.Storage
import kz.dentalcrm.app.data.network.request_model.PositionRequest
import kz.dentalcrm.app.data.network.response_model.positions.Position

class PositionsApi(
    private val httpClient: HttpClient,
    private val storage: Storage,
) {
    suspend fun getPositions() = httpClient.handle<List<Position>> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path("api/v1/positions")
        }
        method = HttpMethod.Get
    }

    suspend fun addPosition(
        name: String,
        description: String
    ) = httpClient.handle<Any?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path("api/v1/positions")
            setBody(
                PositionRequest(
                    name = name,
                    description = description
                )
            )
        }
        method = HttpMethod.Post
    }

    suspend fun deletePosition(
        id: Int,
    ) = httpClient.handle<Any?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path("api/v1/positions/${id}")
        }
        method = HttpMethod.Delete
    }

    suspend fun updatePosition(
        id: Int,
        name: String,
        description: String
    ) = httpClient.handle<Any?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path("api/v1/positions/${id}")
            setBody(
                PositionRequest(
                    name = name,
                    description = description
                )
            )
        }
        method = HttpMethod.Put
    }
}
